"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollAlternativeSchema = exports.MultiChoicePollAlternativeSchema = exports.MULTI_CHOICE_ALTERNATIVE_BG_TYPES = exports.VoteSliderPollAlternativeSchema = exports.ThisOrThatPollAlternativeSchema = exports.POST_STATES = exports.POLL_TYPES = void 0;
exports.isPortalPostState = isPortalPostState;
exports.isPollData = isPollData;
exports.isPollSize = isPollSize;
exports.isThisOrThatPollAlternative = isThisOrThatPollAlternative;
exports.isVoteSliderPollAlternative = isVoteSliderPollAlternative;
exports.isMultiChoicePollAlternative = isMultiChoicePollAlternative;
exports.isAlternativeBackgroundType = isAlternativeBackgroundType;
const zod_1 = require("zod");
exports.POLL_TYPES = ['ThisOrThat', 'VoteSlider', 'MultiChoice'];
exports.POST_STATES = [
    'todo',
    'in_progress',
    'in_review',
    'ready',
];
function isPortalPostState(state) {
    return (state === 'todo' ||
        state === 'in_progress' ||
        state === 'in_review' ||
        state === 'ready');
}
function isPollData(data) {
    return (data !== null &&
        typeof data === 'object' &&
        '$type' in data &&
        typeof data.$type === 'string' &&
        exports.POLL_TYPES.includes(data.$type));
}
function isPollSize(size) {
    return size === 'Medium' || size === 'Large';
}
const UnityColorSchema = zod_1.z.object({
    r: zod_1.z.number(),
    g: zod_1.z.number(),
    b: zod_1.z.number(),
    a: zod_1.z.number(),
});
exports.ThisOrThatPollAlternativeSchema = zod_1.z.object({
    result: zod_1.z.number(),
    iconName: zod_1.z.string(),
    backgroundColor: UnityColorSchema,
    textColor: UnityColorSchema,
});
exports.VoteSliderPollAlternativeSchema = zod_1.z.object({
    result: zod_1.z.number(),
    iconName: zod_1.z.string(),
});
exports.MULTI_CHOICE_ALTERNATIVE_BG_TYPES = [
    'plain',
    'radialGradient',
    'lightRays',
];
exports.MultiChoicePollAlternativeSchema = zod_1.z
    .object({
    result: zod_1.z.number(),
    iconName: zod_1.z.string().optional(),
    url: zod_1.z.string().optional(),
    backgroundColor: UnityColorSchema,
    backgroundType: zod_1.z.enum(exports.MULTI_CHOICE_ALTERNATIVE_BG_TYPES),
})
    .refine((alternative) => alternative.iconName !== undefined || alternative.url !== undefined);
exports.PollAlternativeSchema = zod_1.z.union([
    exports.ThisOrThatPollAlternativeSchema,
    exports.MultiChoicePollAlternativeSchema,
    exports.VoteSliderPollAlternativeSchema,
]);
function isThisOrThatPollAlternative(alternative) {
    return exports.ThisOrThatPollAlternativeSchema.safeParse(alternative).success;
}
function isVoteSliderPollAlternative(alternative) {
    return exports.VoteSliderPollAlternativeSchema.safeParse(alternative).success;
}
function isMultiChoicePollAlternative(alternative) {
    return exports.MultiChoicePollAlternativeSchema.safeParse(alternative).success;
}
function isAlternativeBackgroundType(value) {
    return (typeof value === 'string' &&
        exports.MULTI_CHOICE_ALTERNATIVE_BG_TYPES.includes(value));
}
